export default [
// *===================Chart Of Account List============================---*
{
    path: '/chartofaccounts/list',
        name: 'chartofaccounts-list',
        component: () => import('@/views/accounting/chartofaccounts/chartofaccounts-list/ChartOfAccount.vue'),
        meta: {
            pageTitle: 'Chart Of Account List',
            breadcrumb: [
                {
                    text: 'Chart Of Account List',
                    active: true,
                },
            ],
            //permission: 'Permissions.Accounting.View'            
        },
}
]